// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img-size {
  width: auto;
  height: auto;
  max-width: 160px;
  max-height: 100%;
  align-self: center;
}

:root {
  --logo-fill-color: #025EA1;
}

.theme-dark {
  --logo-fill-color: #6CACE4;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
